const getRedditTag = (): Function | undefined => {
  type WindowWithDataLayer = Window & {
    rdt?: Function;
  };

  return (window as unknown as WindowWithDataLayer)?.rdt;
};

type TrackingParams = {
  email: string;
  currency: string;
  value: number;
  conversionId: string;
  products?: { id: string; category: string; name: string }[];
};

export const trackRedditPurchase = (params: TrackingParams) => {
  const rdt = getRedditTag();

  rdt?.('track', 'Purchase', params);
};
